import {Wrapper} from '@googlemaps/react-wrapper';
import React, {useEffect, useRef, useState} from 'react';
import {Box} from '@mui/material';

const DEFAULT_CENTER = {lat: -24.370286, lng: 133.874289};
const DEFAULT_ZOOM = 4;

let marker = null;
let circle = null;

export const GoogleMapsWrapper = ({children}) => {
  const apiKey = process.env.REACT_APP_GOOGLE_API_KEY;

  if (!apiKey) {
    return <div/>;
  }

  return <Wrapper apiKey={apiKey}>{children}</Wrapper>;
};

const GoogleMap = ({
                     ContainerProps,
                     selectedRadius,
                     zoom,
                     withFullMode = true,
                   }) => {
  const [selectedPosition, setSelectedPosition] = useState({lat: 51.9219336754975, lng: 7.67972242218955});
  const ref = useRef(null);
  const [mapInstance, setMapInstance] = useState(null);

  const initMap = () => {
    setTimeout(() => {
      if (ref.current && window.google) {
        setMapInstance(
          new window.google.maps.Map(ref.current, {
            center: selectedPosition || DEFAULT_CENTER,
            zoom: zoom || DEFAULT_ZOOM,
            fullscreenControl: withFullMode,
          }),
        );
      } else {
        initMap();
      }
    }, 400);
  };

  const changeMarker = (position, center = true) => {
    if (mapInstance) {
      if (marker) {
        marker.setPosition(position);
      } else {
        marker = new window.google.maps.Marker({
          position,
          map: mapInstance,
          title: 'Selected location',
        });
      }
      if (center) {
        mapInstance.panTo(position);
        changeCircle(position);
      }
    }
  };

  const changeCircle = (position) => {
    if (selectedRadius && mapInstance) {
      if (circle) {
        circle.setRadius(selectedRadius);
        circle.setCenter(position);
      } else {
        circle = new window.google.maps.Circle({
          strokeOpacity: 0.2,
          strokeWeight: 0,
          fillColor: '#088CEF',
          fillOpacity: 0.35,
          map: mapInstance,
          center: position,
          radius: selectedRadius,
        });
      }
    }
  };

  useEffect(() => {
    if (mapInstance) {
      mapInstance.addListener('click', (event) => {
        if (event.latLng) {
          const position = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
          };

          changeMarker(position, false);
          changeCircle(position);

          setSelectedPosition(position);
        }
      });
    }
  }, [mapInstance]);

  const changeSelectedPosition = () => {
    if (mapInstance) {
      changeMarker(selectedPosition || DEFAULT_CENTER);
    }
  };

  useEffect(() => {
    changeSelectedPosition();
  }, [selectedPosition, mapInstance]);

  useEffect(() => {
    changeCircle(selectedPosition || DEFAULT_CENTER);
  }, [selectedRadius, mapInstance]);

  useEffect(() => {
    initMap();
  }, [ref]);

  useEffect(() => {
    return () => {
      marker = null;
      circle = null;
    };
  }, []);

  return (
    <GoogleMapsWrapper>
      <Box {...ContainerProps} ref={ref}/>
    </GoogleMapsWrapper>
  );
};

export default GoogleMap;
